import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import OnHover from "./use-on-hover";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "use-on-hover"
    }}>{`use-on-hover`}</h1>
    <p>{`Hook Description`}</p>
    <Playground __position={0} __code={'<OnHover />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      OnHover
    }} mdxType="Playground">
  <OnHover mdxType="OnHover" />
    </Playground>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { useRef } from "react";
import { useOnHover } from "react-hooks-lab";

const YourComponent = () => {
  useOnHover(hoverRef, onHoverIn, onHoverOut);

  function onHoverIn() {
    hoverRef.current.style.backgroundColor = "green";
  }

  function onHoverOut() {
    hoverRef.current.style.backgroundColor = "red";
  }

  return <div ref={hoverRef}>Hover me</div>;
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      